import React from 'react';
import StaffMemberCard from './StaffMemberCard';

const OurStaff = ({ data = {} }) => {
  const providers = data.providers || [];
  const staff = data.staff || [];

  function stripTags(htmlString = '') {
    return htmlString.replace(/<\/?[^>]+(>|$)/g, '');
  }

  return (
    <div className="max-w-4xl mx-auto p-4">
      <section id="providers">
        <h1 className="text-4xl text-black font-bold mb-4">Providers</h1>
        <hr className="mb-8 border-gray-400" />

        {providers.length === 0 ? (
          <p className="text-gray-600">Loading providers...</p>
        ) : (
          providers.map((provider, index) => (
            <StaffMemberCard
              key={index}
              name={provider.name}
              title={provider.title}
              bio={stripTags(provider.bio)}
              picture={provider.picture}
            />
          ))
        )}
      </section>

      <section id="staff" className="mt-16">
        <h1 className="text-4xl text-black font-bold mb-4">Staff</h1>
        <hr className="mb-8 border-gray-400" />

        {staff.length === 0 ? (
          <p className="text-gray-600">Loading staff...</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {staff.map((staffMember, index) => (
              <StaffMemberCard
                key={index}
                name={staffMember.name}
                title={staffMember.title}
                picture={staffMember.picture}
              />
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default OurStaff;